// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__z3p2l","colCheckbox":"styles_colCheckbox__2a1w0"};